import { basicAccountInfo } from "api/basic_account_info";
import {  generic_put_api } from "api/generic_api";
import { Component } from "react";
import { Button } from 'react-bootstrap';
import { CODE_TABLES } from 'utils/constants';
import { EventNames, trackEvent } from 'utils/mixpanel';


class CodeTables extends Component {

    constructor(props) {
        super(props);

        this.state = {
            method: null,
            session_ok: false,
            working: false,
            file_name: null,
            section: null,
            order: null,
            table_number: null,
            table_title: null,
            foot_note_1: null,
            foot_note_2: null,
            foot_note_3: null,
        };
        this.saveFiles = this.saveFiles.bind(this);
        this.resetEverythingAndFetch = this.resetEverythingAndFetch.bind(this);
    }

    resetEverythingAndFetch() {
        this.setState({ parts: [] }, this.fetchCodeParts);
    }

    saveFiles() {
        this.setState({working: true });

        let foot_notes = [];

        if (this.state.foot_note_1){
            foot_notes.push(this.state.foot_note_1);
        }

        if (this.state.foot_note_2){
            foot_notes.push(this.state.foot_note_2);
        }

        if (this.state.foot_note_3){
            foot_notes.push(this.state.foot_note_3);
        }

        let request = {
            file_name: this.state.file_name,
            section: this.state.section,
            method: this.state.method,
            order: this.state.order,
            table_number: this.state.table_number,
            table_title: this.state.table_title,
            foot_notes: foot_notes,

        }

        generic_put_api(CODE_TABLES, request)
            .then(
                (result) => {
                    if(result.status === 204) {
                        this.setState(
                            {
                                method: null,
                                section: null,
                                file_name: null,
                                working: false,
                                order: null,
                                table_number: null,
                                table_title: null,
                                foot_note_1: null,
                                foot_note_2: null,
                                foot_note_3: null,
                            });
                    }
                }
            ).catch(error => {
            });
    }

    componentDidMount() {
        trackEvent(EventNames.PAGE_LOAD, {'data_1': 'code_parts'});
        basicAccountInfo()
        .then(
            data => {
                this.setState({session_ok: true});
            }
        ).catch(error => {
            if (error?.name === 'LOGIN_ERROR') {
                this.props.history.push('/login');
            }
        });

    }

    render() {
        const {working, section, order, table_title, table_number, foot_note_1, foot_note_2, foot_note_3, method, file_name} = this.state;

        return(
            <div class="container-fluid codeLabel ps-4">

                {this.state.session_ok && 
                    <>
                        <div class="row">
                        <div class="form-check">
                                <input class="form-check-input" type="radio" name="radioDefault" id="radioDefault1"
                                                            checked={'pdf_to_table' === method}
                                                            onChange={() => this.setState({method: 'pdf_to_table'})}/>

                                <label class="form-check-label" for="radioDefault1">
                                    Pdf to table
                                </label>
                                </div>
                                <div class="form-check">
                                <input class="form-check-input" type="radio" name="radioDefault" id="radioDefault2" 
                                    checked={'import_table' === method}
                                    onChange={() => this.setState({method: 'import_table'})}/>

                                <label class="form-check-label" for="radioDefault2">
                                    Import table
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-auto me-3">
                                <input type="text" class="form-control" value={file_name} placeholder="file_name" onChange={(e) => this.setState({file_name: e.target.value})}/> 
                            </div>
                            {/* <div class="col-auto me-3 text-start"><Button variant="secondary" onClick={ this.resetEverythingAndFetch }>OK</Button></div> */}
                        </div>
                    </>
                }

                {
                    working && 
                    <div class="container mt-5 text-center">
                        <span class="spinner-border" aria-hidden="true"></span>
                    </div>
                }
                
                {  
                    method === 'import_table' &&
                    <>
                        <div class="mt-2"><input type="text" class="form-control" value={section} placeholder="Section" onChange={(e) => this.setState({section: e.target.value})}/> </div>
                        <div class="mt-2"><input type="text" class="form-control" value={order} placeholder="order" onChange={(e) => this.setState({order: e.target.value})}/> </div>
                        <div class="mt-2"><input type="text" class="form-control" value={table_number} placeholder="table number" onChange={(e) => this.setState({table_number: e.target.value})}/> </div>
                        <div class="mt-2"><input type="text" class="form-control" value={table_title} placeholder="table title" onChange={(e) => this.setState({table_title: e.target.value})}/> </div>
                        <div class="mt-2"><input type="text" class="form-control" value={foot_note_1} placeholder="foot note 1" onChange={(e) => this.setState({foot_note_1: e.target.value})}/> </div>
                        <div class="mt-2"><input type="text" class="form-control" value={foot_note_2} placeholder="foot note 2" onChange={(e) => this.setState({foot_note_2: e.target.value})}/> </div>
                        <div class="mt-2"><input type="text" class="form-control" value={foot_note_3} placeholder="foot note 3" onChange={(e) => this.setState({foot_note_3: e.target.value})}/> </div>
                    </>
                }
                {
                    <div class="row mt-4"><div class="col"><Button onClick={this.saveFiles}>Save</Button></div></div>
                }
            </div>
        )
    }
}

export default CodeTables;